// extracted by mini-css-extract-plugin
export default {"printHoldRequestsForm":"printHoldRequestsForm---D8nqv"};